import Request from '@/plugins/request';

export function getStagentFunds(params) {
  return Request.get('stagent-funds', { params })
}

export function createStagentFund() {
  return Request.get(`stagent-funds/create`)
}

export function storeStagentFund(data) {
  return Request.post('stagent-funds', data)
}

export function updateStagentFund(id, data) {
  return Request.put(`stagent-funds/${id}`, data)
}

export function editStagentFund(id) {
  return Request.get(`stagent-funds/${id}/edit`)
}

export function destroyStagentFund(id) {
  return Request.delete(`stagent-funds/${id}`)
}
